import { type FC, useMemo } from "react";
import { IncludesSurchargeDisclaimer } from "~/domains/pricing/components/IncludesSurchargeDisclaimer";
import { type DetailedOrderData } from "~/domains/orders/types/modelsV2";
import { useTranslation } from "react-i18next";
import { Box, Stack, Typography } from "~/common/mui";
import DeliveryInformationV2 from "./DeliveryInformationV2";
import PackageTableV2 from "./PackageTableV2";

interface ShipmentDetailsProps {
  data: DetailedOrderData;
}

const ShipmentDetailsV2: FC<ShipmentDetailsProps> = ({ data }) => {
  const { t } = useTranslation();
  const deliveryEntries = data.deliveryEntries;
  const shipmentInformationDataWrapper = data.shipmentInformationDataWrapper ?? { orderDetailsData: {} };

  const constainsSurcharge = useMemo(() => {
    return data.products.length > 0 && data.products.some((lineItem) => lineItem.netPrice.surcharge > 0);
  }, [data]);

  return (
    <Stack gap={2}>
      {deliveryEntries.map((deliveryEntry, index) => {
        return (
          <Stack key={index} gap={1}>
            <Box>
              <Typography variant="titleMedium" component={"b"}>
                {t("shipmentDetails.delivery.text", {
                  index: index + 1,
                })}
              </Typography>
            </Box>
            <Box>
              <DeliveryInformationV2 data={deliveryEntry} freightPayment={data.freightPayment} />
              <PackageTableV2
                deliveryEntryData={deliveryEntry}
                shipmentInformationDataWrapper={shipmentInformationDataWrapper}
              />
            </Box>
          </Stack>
        );
      })}
      {<IncludesSurchargeDisclaimer hasSurcharge={constainsSurcharge} />}
    </Stack>
  );
};

export default ShipmentDetailsV2;
